import React, { FC } from 'react';
import { Form, Modal } from 'react-bootstrap';
import styles from './CommodityModal.module.css';
import { Button } from '../../atoms';
import { CustomDropdown } from '../../molecules';
import { CommodityResponseDto } from '../../../store/tradeAPI/commodity/dto/response/commodity-response.dto';
import { DropdownItem } from '../../molecules/CustomDropdown/CustomDropdown';
import cn from 'classnames';

interface CommodityModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  commodities: CommodityResponseDto[];
  handleSubmit: () => void;
  setSelectedCommodity: React.Dispatch<
    React.SetStateAction<CommodityResponseDto | undefined>
  >;
}

const CommodityModal: FC<CommodityModalProps> = ({
  show,
  setShow,
  commodities,
  handleSubmit,
  setSelectedCommodity,
}) => {
  const items: DropdownItem[] = commodities.map((c) => {
    return {
      label: c.name,
      eventKey: c.id,
    };
  });

  return (
    <Modal centered show={show} onHide={() => setShow(false)}>
      <div className={cn(styles.modal)}>
        <Modal.Body className={styles.modalBody}>
          <Form.Group>
            <Form.Label>Commodity</Form.Label>
            <CustomDropdown
              initialTitle="Please select a Commodity"
              items={items}
              onSelectOption={(dropdownItem) => {
                const selectedCommodity = commodities.find(
                  (c) => c.id === dropdownItem.eventKey
                );
                setSelectedCommodity(selectedCommodity);
              }}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className={styles.modalButtons}>
          <Button
            onClick={handleSubmit}
            className={styles.button}
            variant="dark"
          >
            Save
          </Button>
          <Button
            className={styles.button}
            variant="light"
            onClick={() => setShow(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default CommodityModal;
